"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
var _layouts = require("@seedlang/layouts");
var _lodash = require("lodash");
var _models = require("@seedlang/models");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseUI = (_class = /*#__PURE__*/function (_RootState) {
  function ExerciseUI() {
    var _this;
    _classCallCheck(this, ExerciseUI);
    _this = _callSuper(this, ExerciseUI);
    _initializerDefineProperty(_this, "groupId", _descriptor, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor2, _this);
    _initializerDefineProperty(_this, "exerciseId", _descriptor3, _this);
    _initializerDefineProperty(_this, "assignedExercise", _descriptor4, _this);
    _initializerDefineProperty(_this, "revealed", _descriptor5, _this);
    _initializerDefineProperty(_this, "currentCardId", _descriptor6, _this);
    _initializerDefineProperty(_this, "showAllWorksheetVocab", _descriptor7, _this);
    _initializerDefineProperty(_this, "exercises", _descriptor8, _this);
    _initializerDefineProperty(_this, "exerciseRatingId", _descriptor9, _this);
    _this.layout = new _layouts.AppLayout(_this);
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.authUserStore = _stores.AuthUserStore;
    _this.routeStore = _stores.RouteStore;
    _this.exerciseStore = _stores.ExerciseStore;
    _this.worksheetUserExerciseStore = _stores.WorksheetUserExerciseStore;
    _this.exerciseEntryStore = _stores.ExerciseEntryStore;
    _this.exerciseTypeStore = _stores.ExerciseTypeStore;
    _this.groupStore = _stores.GroupStore;
    _this.worksheetStore = _stores.WorksheetStore;
    _this.recentWorksheetStore = _stores.RecentWorksheetStore;
    _this.gridItemStore = _stores.GridItemStore;
    _this.gridItemWorksheetStore = _stores.GridItemWorksheetStore;
    _this.userGroupStore = _stores.UserGroupStore;
    _this.userExerciseStore = _stores.UserExerciseStore;
    _this.mediaOptionStore = _stores.MediaOptionStore;
    _this.tagCategoryStore = _stores.TagCategoryStore;
    _this.eventStore = _stores.EventStore;
    _this.worksheetWordStore = _stores.WorksheetWordStore;
    _this.cookieStore = _stores.CookieStore;
    _this.ratingStore = _stores.RatingStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    _this.showAllWorksheetVocab = _this.getCookieValue('show_all_worksheet_vocab');
    return _this;
  }
  _inherits(ExerciseUI, _RootState);
  return _createClass(ExerciseUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userGroup",
    get: function get() {
      var _this2 = this;
      return this.userIsLoaded && this.groupId && this.user.userGroups.find(function (item) {
        return item.groupId === _this2.groupId;
      });
    }
  }, {
    key: "defaultExerciseId",
    get: function get() {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises)) {
        var _this$worksheet;
        return (_this$worksheet = this.worksheet) === null || _this$worksheet === void 0 || (_this$worksheet = _this$worksheet.exercises[0]) === null || _this$worksheet === void 0 ? void 0 : _this$worksheet.id;
      }
    }
  }, {
    key: "site",
    get: function get() {
      return this.userIsLoaded ? this.user.site : {};
    }
  }, {
    key: "languageId",
    get: function get() {
      var _this$site;
      return this.siteIsDefault ? 'DE' : (_this$site = this.site) === null || _this$site === void 0 ? void 0 : _this$site.languageId;
    }
  }, {
    key: "siteIsDefault",
    get: function get() {
      return this.site.isDefault;
    }
  }, {
    key: "userIsSignedInAndNotGuest",
    get: function get() {
      return this.userIsLoaded && !this.user.guest;
    }
  }, {
    key: "worksheetWords",
    get: function get() {
      return this.worksheetWordStore.hasIndexData && this.worksheetWordStore.indexData;
    }
  }, {
    key: "filteredWorksheetWords",
    get: function get() {
      return this.worksheetWordStore.hasIndexData && this.worksheetWords.filter(function (item) {
        return !item.invalid;
      });
    }
  }, {
    key: "worksheetHasInvalidVocab",
    get: function get() {
      return this.worksheetWords && (0, _lodash.some)(this.worksheetWords.map(function (item) {
        return item.invalid;
      }));
    }
  }, {
    key: "defaultSiteHasWorksheetAccess",
    get: function get() {
      return this.siteIsDefault && (this.user.permanentPatreonMember || this.user.activePatreonMember);
    }
  }, {
    key: "hasWorksheetAccess",
    value: function hasWorksheetAccess(worksheet) {
      var _this$site2, _worksheet$podcastEpi, _worksheet$podcastEpi2;
      if (this.user.isAdminForSite((_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.id)) return true;
      if (this.defaultSiteHasWorksheetAccess) return true;
      if (!worksheet || !this.userGroup) return false;
      if (worksheet.accessWithoutMembership && this.userIsSignedInAndNotGuest) return true;
      if (!this.user.isMember) return false;
      var membershipTypes = (_worksheet$podcastEpi = (_worksheet$podcastEpi2 = worksheet.podcastEpisode) === null || _worksheet$podcastEpi2 === void 0 || (_worksheet$podcastEpi2 = _worksheet$podcastEpi2.podcast) === null || _worksheet$podcastEpi2 === void 0 ? void 0 : _worksheet$podcastEpi2.podcastMembershipTypes) !== null && _worksheet$podcastEpi !== void 0 ? _worksheet$podcastEpi : [];
      if (membershipTypes.length === 0) return true;
      return (0, _lodash.some)(membershipTypes, (0, _lodash.pick)(this.userGroup, 'membershipTypeId'));
    }
  }, {
    key: "hasCurrentWorksheetAccess",
    get: function get() {
      return this.hasWorksheetAccess(this.worksheet);
    }
  }, {
    key: "group",
    get: function get() {
      return this.groupStore.showData;
    }
  }, {
    key: "formattedYoutubeUrl",
    get: function get() {
      if (this.worksheetId && this.hasWorksheet) {
        return this.worksheet.formattedYoutubeUrl;
      }
      if (!this.worksheetId && this.exercise && this.exercise.worksheet) {
        return this.exercise.worksheet.formattedYoutubeUrl;
      }
    }
  }, {
    key: "hasGroup",
    get: function get() {
      return (0, _utils.isPresent)(this.group);
    }
  }, {
    key: "userExercise",
    get: function get() {
      var _this3 = this;
      return this.worksheetUserExerciseStore.hasIndexData ? this.worksheetUserExerciseStore.indexData.find(function (item) {
        return item.exerciseId === _this3.exerciseId;
      }) : {};
    }
  }, {
    key: "worksheet",
    get: function get() {
      return this.worksheetStore.showData;
    }
  }, {
    key: "hasWorksheet",
    get: function get() {
      return this.worksheetStore.hasShowData;
    }
  }, {
    key: "exercise",
    get: function get() {
      var _this4 = this;
      if ((0, _utils.isPresent)(this.currentCardId) && this.exercises[this.currentCardId]) {
        return this.exercises[this.currentCardId];
      }
      if (this.exerciseStore.hasShowData && this.exerciseStore.showData.id === this.exerciseId) {
        return this.exerciseStore.showData;
      }
      if (this.hasWorksheet && this.exerciseId && (0, _utils.isPresent)(this.worksheet.exercises)) {
        return this.worksheet.exercises.find(function (item) {
          return item.id === _this4.exerciseId;
        });
      }
    }
  }, {
    key: "exerciseIsLast",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.exerciseIndex === this.worksheet.exercises.length - 1;
    }
  }, {
    key: "exerciseIsFirst",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.exerciseIndex === 0;
    }
  }, {
    key: "exerciseIndex",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseId) && (0, _utils.isPresent)(this.worksheet.exercises) && this.worksheet.exercises.map(function (item) {
        return item.id;
      }).indexOf(this.exerciseId);
    }
  }, {
    key: "assignExerciseToCard",
    value: function assignExerciseToCard(cardId, exercise) {
      this.exercises[cardId] = exercise;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "hasExercise",
    get: function get() {
      return (0, _utils.isPresent)(this.exercise);
    }
  }, {
    key: "toggleHideYoutubeVideo",
    value: function toggleHideYoutubeVideo() {
      var hideYoutubeVideo = !this.user.hideYoutubeVideo;
      this.updateUser('hideYoutubeVideo', hideYoutubeVideo);
    }
  }, {
    key: "toggleShowAllWorksheetVocab",
    value: function toggleShowAllWorksheetVocab() {
      var showAllWorksheetVocab = !this.user.showAllWorksheetVocab;
      this.updateUser('showAllWorksheetVocab', showAllWorksheetVocab);
    }
  }, {
    key: "updateUser",
    value: function updateUser(field, value) {
      var data = {};
      data[field] = value;
      this.user.set(field, value);
      this.authUserStore.update({
        data: data
      }, _lodash.noop);
    }
  }, {
    key: "createEvent",
    value: function createEvent(eventType, params) {
      if (!this.user.blockUserTracking) {
        this.eventStore.create({
          data: {
            eventType: eventType,
            params: params
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "assignToNextWordAssociation",
    value: function assignToNextWordAssociation(submittedWordAssociation, sentenceId, clickWithinSentence) {
      var _this5 = this;
      var assigned = false;
      (0, _lodash.each)(this.exercise.exerciseEntries, function (exerciseEntry) {
        if (!assigned && (!clickWithinSentence || !sentenceId || exerciseEntry.sentence.id === sentenceId)) {
          var nextAvailableWordAssociation = exerciseEntry.sentence.wordAssociations.find(function (item) {
            return item.selected && (0, _utils.isBlank)(item.state.submittedValue);
          });
          if ((0, _utils.isPresent)(nextAvailableWordAssociation)) {
            assigned = true;
            exerciseEntry.sentence.state.assignedWordAssociationIds.push(submittedWordAssociation.id);
            _this5.onSetValueToWordAssociation(nextAvailableWordAssociation.id, submittedWordAssociation);
          }
        }
      });
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue(name) {
      return this.cookieStore.getCookieValue(name);
    }
  }, {
    key: "setCookieValue",
    value: function setCookieValue(name, value) {
      this.cookieStore.setCookieValue(name, value);
    }
  }, {
    key: "assignToNextExerciseEntry",
    value: function assignToNextExerciseEntry(submittedExerciseEntry) {
      var exerciseEntry = this.exercise.exerciseEntries.find(function (item) {
        return (0, _utils.isBlank)(item.state.assignedExerciseEntry);
      });
      if (exerciseEntry) {
        exerciseEntry.state.set('assignedExerciseEntry', {
          id: submittedExerciseEntry.id,
          prompt: submittedExerciseEntry.prompt
        });
      }
      var submitted = this.exercise.exerciseEntries.find(function (item) {
        return item.id === submittedExerciseEntry.id;
      });
      if (submitted) {
        submitted.state.set('assigned', true);
      }
    }
  }, {
    key: "removeExerciseEntry",
    value: function removeExerciseEntry(exerciseEntry) {
      var assignedExerciseEntry = this.exercise.exerciseEntries.find(function (item) {
        return item.id === exerciseEntry.state.assignedExerciseEntry.id;
      });
      if (assignedExerciseEntry) {
        assignedExerciseEntry.state.set('assigned', false);
      }
      this.exercise.state.removeExerciseEntryId(exerciseEntry.state.assignedExerciseEntry.id);
      exerciseEntry.state.reset();
    }
  }, {
    key: "onSetValueToWordAssociation",
    value: function onSetValueToWordAssociation(wordAssociationId, submittedWordAssociation) {
      var _this6 = this;
      var wordAssociation;
      (0, _lodash.each)(this.exercise.exerciseEntries, function (exerciseEntry) {
        wordAssociation = exerciseEntry.sentence.wordAssociations.find(function (item) {
          return item.id === wordAssociationId;
        });
        if ((0, _utils.isPresent)(wordAssociation)) {
          exerciseEntry.sentence.state.assignedWordAssociationIds.push(submittedWordAssociation.id);
          submittedWordAssociation.state.set('assigned', true);
          wordAssociation.state.set('submittedValue', submittedWordAssociation.targetText);
          wordAssociation.state.set('submittedWordAssociation', submittedWordAssociation);
        }
        if (!_this6.hasWorksheet && exerciseEntry.sentence.allWordAssociationsHaveValues) {
          _this6.revealed = true;
        }
      });
    }
  }, {
    key: "clearWordAssociation",
    value: function clearWordAssociation(wa, sentence) {
      if ((0, _utils.isPresent)(wa.state.submittedWordAssociation)) {
        wa.state.submittedWordAssociation.state.set('assigned', false);
      }
      if (sentence && wa.state.submittedWordAssociation) {
        sentence.state.removeAssignedWordAssociation(wa.state.submittedWordAssociation.id);
      }
      if (wa.state.submittedWordAssociation) {
        this.exercise.state.removeAssignedWordAssociation(wa.state.submittedWordAssociation.id);
      }
      wa.state.set('submittedValue', null);
    }
  }, {
    key: "setAssignedWordAssociations",
    value: function setAssignedWordAssociations(wordAssociation, sentence) {
      if (this.exercise && this.exercise.state) {
        this.exercise.state.assignedWordAssociationIds.push(wordAssociation.id);
        if (sentence) {
          sentence.state.assignedWordAssociationIds.push(wordAssociation.id);
        }
      }
    }
  }, {
    key: "correctAnswersCount",
    value: function correctAnswersCount(exerciseId) {
      if (this.worksheetUserExerciseStore.hasIndexData) {
        var userExercise = this.worksheetUserExerciseStore.indexData.find(function (item) {
          return item.exerciseId === exerciseId;
        });
        if ((0, _utils.isPresent)(userExercise)) {
          return userExercise.correctAnswersCount;
        }
      }
      return 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.resetExerciseAnswers();
      this.currentCardId = null;
    }
  }, {
    key: "resetExerciseAnswers",
    value: function resetExerciseAnswers() {
      this.revealed = false;
      if (this.exercise && this.exercise.state) {
        this.exercise.state.set('revealed', false);
        this.exercise.state.reset();
        (0, _lodash.each)(this.exercise.exerciseEntries, function (exerciseEntry) {
          exerciseEntry.state.reset();
        });
      }
    }
  }, {
    key: "resetIncorrectExerciseAnswers",
    value: function resetIncorrectExerciseAnswers() {
      var _this7 = this;
      this.revealed = false;
      if (this.exercise) {
        this.exercise.state.set('revealed', false);
      }
      (0, _lodash.each)(this.exercise.exerciseEntries, function (exerciseEntry) {
        _this7.resetIncorrectExerciseEntryAnswers(exerciseEntry);
      });
    }
  }, {
    key: "revealedEntriesCount",
    get: function get() {
      return this.exercise.exerciseEntries.filter(function (item) {
        return item.state.revealed;
      }).length;
    }
  }, {
    key: "revealedEntriesCorrectCount",
    get: function get() {
      return this.exercise.exerciseEntries.filter(function (item) {
        return item.state.revealed && item.state.correct;
      }).length;
    }
  }, {
    key: "revealExerciseEntryAnswer",
    value: function revealExerciseEntryAnswer(exerciseEntry) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      if (this.revealedEntriesCount === this.exercise.exerciseEntriesCount - 1) {
        this.revealExerciseAnswers(params);
      } else {
        exerciseEntry.state.evaluate(this.exercise);
        if (!params.skipAudio && exerciseEntry.state.correct) {
          this.exercise.set('correctAnswersCount', this.revealedEntriesCorrectCount);
          if ((0, _utils.isPresent)(this.userExercise)) {
            this.userExercise.set('correctAnswersCount', this.revealedEntriesCorrectCount);
          }
        }
        if ((0, _utils.isPresent)(this.userExercise) && exerciseEntry.state.correct) {
          this.worksheetUserExerciseStore.update({
            ids: {
              userExerciseId: this.userExercise.id
            },
            data: {
              correct_answers_count: this.revealedEntriesCorrectCount,
              submitted_values: this.exercise.exerciseEntries.map(function (item) {
                return item.state.submittedValue;
              })
            }
          }, this.reloadUser);
        }
      }
      this.updateIndexDataAfterReveal();
      if ((0, _lodash.isFunction)(callback)) {
        callback();
      }
    }
  }, {
    key: "resetIncorrectExerciseEntryAnswers",
    value: function resetIncorrectExerciseEntryAnswers(exerciseEntry) {
      if (!exerciseEntry.state.correct) {
        var _this$exercise;
        var skipSentence = ['wordEnter', 'drag'].includes((_this$exercise = this.exercise) === null || _this$exercise === void 0 || (_this$exercise = _this$exercise.exerciseType) === null || _this$exercise === void 0 ? void 0 : _this$exercise.slug);
        exerciseEntry.state.reset({
          skipSentence: skipSentence
        });
        if (skipSentence) {
          var _exerciseEntry$senten;
          (_exerciseEntry$senten = exerciseEntry.sentence) === null || _exerciseEntry$senten === void 0 || (_exerciseEntry$senten = _exerciseEntry$senten.wordAssociations) === null || _exerciseEntry$senten === void 0 || _exerciseEntry$senten.forEach(function (wordAssociation) {
            if (wordAssociation.selected && !wordAssociation.state.correct) {
              wordAssociation.state.reset();
            }
          });
        }
      }
      if (this.exercise.state.revealed) {
        this.exercise.state.set('revealed', false);
      }
    }
  }, {
    key: "revealExerciseAnswers",
    value: function revealExerciseAnswers() {
      var _this8 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var correct = 0;
      if (!this.exercise || !this.exercise.state) {
        return;
      }
      if (!this.exercise.state.revealed) {
        this.revealed = true;
        this.exercise.state.set('revealed', true);
        this.exercise.state.set('hasBeenRevealed', true);
        (0, _lodash.each)(this.exercise.exerciseEntries, function (exerciseEntry) {
          exerciseEntry.state.evaluate(_this8.exercise);
          if (exerciseEntry.state.correct) {
            correct += 1;
          }
        });
        if (correct === this.exercise.exerciseEntriesCount && params.correctCallback) {
          if (!params.skipAudio) {
            this.soundEffectStore.play('horn');
          }
          params.correctCallback();
        } else if (correct === this.exercise.exerciseEntriesCount) {
          if (!params.skipAudio) {
            this.soundEffectStore.play('horn');
            if (this.siteIsDefault) {
              this.soundEffectStore.play('correct');
            }
          }
          this.xpState.createXpAnimation({
            xp: this.exercise.exerciseEntriesCount,
            id: (0, _utils.createUuid)(),
            namespace: 'user-exercise-show',
            xpXPos: 200
          });
        } else if (correct !== this.exercise.exerciseEntriesCount && params.incorrectCallback) {
          params.incorrectCallback();
        }
        this.exercise.set('correctAnswersCount', correct);
        this.createEvent('worksheets - submit exercise', {
          numberCorrect: correct,
          totalQuestions: this.exercise.exerciseEntriesCount,
          answeredAllCorrectly: this.exercise.exerciseEntriesCount === correct
        });
        if ((0, _utils.isPresent)(this.userExercise)) {
          this.userExercise.set('correctAnswersCount', correct);
          this.worksheetUserExerciseStore.update({
            ids: {
              userExerciseId: this.userExercise.id
            },
            data: {
              correct_answers_count: correct,
              xp_slug: 'user-exercise-correct',
              submitted_values: this.exercise.exerciseEntries.map(function (item) {
                return item.state.submittedValue;
              })
            }
          }, this.reloadUser);
        }
        this.updateIndexDataAfterReveal();
      }
    }
  }, {
    key: "updateIndexDataAfterReveal",
    value: function updateIndexDataAfterReveal() {
      var _this9 = this;
      if ((0, _utils.isPresent)(this.worksheetId) && this.worksheetUserExerciseStore.hasIndexData) {
        var totalCorrectAnswersCount = (0, _lodash.sum)(this.worksheetUserExerciseStore.indexData.map(function (item) {
          return item.correctAnswersCount;
        }));
        if (this.worksheetStore.hasIndexData) {
          var worksheetData = this.worksheetStore.indexData.find(function (item) {
            return (item === null || item === void 0 ? void 0 : item.id) === _this9.worksheetId;
          });
          if ((0, _utils.isPresent)(worksheetData)) {
            worksheetData.set('correctAnswersCount', totalCorrectAnswersCount);
          }
        }
        if (this.gridItemStore.hasIndexData) {
          this.gridItemStore.indexData.forEach(function (gridItem) {
            var _gridItem$gridItemWor;
            (_gridItem$gridItemWor = gridItem.gridItemWorksheets) === null || _gridItem$gridItemWor === void 0 || _gridItem$gridItemWor.forEach(function (gridItemWorksheet) {
              var _gridItemWorksheet$wo;
              if (((_gridItemWorksheet$wo = gridItemWorksheet.worksheet) === null || _gridItemWorksheet$wo === void 0 ? void 0 : _gridItemWorksheet$wo.id) === _this9.worksheetId) {
                gridItemWorksheet.worksheet.set('correctAnswersCount', totalCorrectAnswersCount);
              }
            });
          });
        }
      }
      if ((0, _utils.isPresent)(this.exerciseId) && this.exerciseStore.hasIndexData && (0, _utils.isPresent)(this.userExercise) && (0, _utils.isPresent)(this.exerciseStore.indexData.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === _this9.exerciseId;
      }))) {
        var exerciseData = this.exerciseStore.indexData.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.id) === _this9.exerciseId;
        });
        exerciseData.set('correctAnswersCount', this.userExercise.correctAnswersCount);
        exerciseData.set('completed', this.userExercise.completed);
      }
    }
  }, {
    key: "enrichExercise",
    value: function enrichExercise(id, callback) {
      var _this10 = this;
      var exercise;
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises)) {
        exercise = this.worksheet.exercises.find(function (item) {
          return item.id === id;
        });
      }
      if (exercise && !exercise.enriched || !this.hasWorksheet) {
        this.exerciseStore.getShow({
          queryStrings: {
            include_worksheet: !this.hasWorksheet
          },
          ids: {
            exerciseId: id
          }
        }, function (resp) {
          _this10.afterGetExercise(resp);
          if (callback) {
            callback();
          }
        });
      }
    }
  }, {
    key: "getWorksheet",
    value: function getWorksheet(worksheetId, callback) {
      var _this11 = this;
      if (this.userIsLoaded) {
        this.worksheetUserExerciseStore.getIndex({
          ids: {
            worksheetId: this.worksheetId
          }
        });
      }
      this.worksheetStore.getShow({
        ids: {
          worksheetId: this.worksheetId,
          groupId: this.groupId
        }
      }, function (resp) {
        if ((0, _utils.isBlank)(_this11.groupId)) {
          _this11.set('groupId', resp.groupId);
        }
        if (callback) {
          callback(resp);
        } else {
          _this11.worksheetStore.afterGetShow(resp);
        }
      });
    }
  }, {
    key: "reloadUser",
    value: function reloadUser() {
      if (this.userIsLoaded) {
        this.authUserStore.getShow({}, _lodash.noop);
      }
    }
  }, {
    key: "afterGetExercise",
    value: function afterGetExercise(resp) {
      if (this.hasWorksheet) {
        var index = (0, _lodash.findIndex)(this.worksheet.exercises, function (item) {
          return item.id === resp.id;
        });
        if (index !== -1) {
          this.worksheet.exercises[index] = (0, _serializr.deserialize)(_models.Exercise, resp);
        }
      } else {
        this.exerciseStore.afterGetShow(resp);
      }
    }
  }, {
    key: "markAsCompleted",
    value: function markAsCompleted() {
      var _this12 = this;
      if (this.userExercise) {
        var _this$worksheet2;
        var newValue = !this.userExercise.completed;
        this.userExercise.set('completed', newValue);
        if ((_this$worksheet2 = this.worksheet) !== null && _this$worksheet2 !== void 0 && _this$worksheet2.exercises) {
          var exercise = this.worksheet.exercises.find(function (item) {
            return item.id === _this12.exerciseId;
          });
          if (!exercise) return;
          exercise.completed = newValue;
        }
        this.updateIndexDataAfterMarkAsCompleted(newValue);
        this.worksheetUserExerciseStore.update({
          ids: {
            userExerciseId: this.userExercise.id
          },
          data: {
            completed: newValue
          }
        });
      }
    }
  }, {
    key: "findExerciseAndMarkAsCompleted",
    value: function findExerciseAndMarkAsCompleted(worksheetList) {
      var _this13 = this;
      worksheetList.forEach(function (worksheet) {
        var _worksheet$exercises;
        (_worksheet$exercises = worksheet.exercises) === null || _worksheet$exercises === void 0 || _worksheet$exercises.forEach(function (exercise) {
          if (exercise.id === _this13.exerciseId) {
            exercise.set('completed', true);
          }
        });
      });
    }
  }, {
    key: "updateIndexDataAfterMarkAsCompleted",
    value: function updateIndexDataAfterMarkAsCompleted(completed) {
      var _this14 = this;
      if (this.worksheetStore.hasIndexData) {
        this.findExerciseAndMarkAsCompleted(this.worksheetStore.indexData);
      }
      if (this.gridItemStore.hasIndexData) {
        this.gridItemStore.indexData.forEach(function (gridItem) {
          _this14.findExerciseAndMarkAsCompleted(gridItem.gridItemWorksheets.map(function (item) {
            return item.worksheet;
          }));
        });
      }
      if (this.recentWorksheetStore.hasIndexData) {
        this.findExerciseAndMarkAsCompleted(this.recentWorksheetStore.indexData);
      }
      if (this.exerciseStore.hasIndexData) {
        this.exerciseStore.indexData.forEach(function (item) {
          if ((item === null || item === void 0 ? void 0 : item.id) === _this14.exerciseId) {
            item.set('completed', completed);
          }
        });
      }
    }
  }, {
    key: "onClickRating",
    value: function onClickRating(rating) {
      var _this15 = this;
      if ((0, _utils.isPresent)(this.userExercise)) {
        var _this$user, _this$worksheet3;
        this.userExercise.set('rating', rating);
        var data = {
          exerciseId: this.exerciseId,
          userId: (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.id,
          rating: rating,
          languageId: this.languageId,
          groupId: (_this$worksheet3 = this.worksheet) === null || _this$worksheet3 === void 0 ? void 0 : _this$worksheet3.groupId
        };
        this.ratingStore.create({
          data: data
        }, function (resp) {
          return _this15.exerciseRatingId = resp.id;
        });
      }
    }
  }, {
    key: "onSubmitRatingComment",
    value: function onSubmitRatingComment(comment) {
      if (this.exerciseRatingId) {
        this.ratingStore.update({
          ids: {
            ratingId: this.exerciseRatingId
          },
          data: {
            comment: comment
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "reviewDeckOptions",
    get: function get() {
      var _this16 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this16.languageId && !item.archived;
      }).map(function (item) {
        return [item.id, item.name];
      });
    }
  }, {
    key: "worksheetNamespace",
    get: function get() {
      var _this$routeStore;
      var routeFirstPart = (_this$routeStore = this.routeStore) === null || _this$routeStore === void 0 || (_this$routeStore = _this$routeStore.routeName) === null || _this$routeStore === void 0 ? void 0 : _this$routeStore.split('.')[0];
      var allowedNamespaces = ['learn', 'worksheets', 'videos', 'podcast'];
      return allowedNamespaces.includes(routeFirstPart) ? routeFirstPart : 'worksheets';
    }
  }, {
    key: "goToNextExercise",
    value: function goToNextExercise(callback, routeName) {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises) && !this.exerciseIsLast) {
        var _this$worksheet$exerc, _this$worksheet4;
        var currentExerciseIndex = this.worksheet.exercises.map(function (item) {
          return item.id;
        }).indexOf(this.exerciseId);
        var nextExerciseId = (_this$worksheet$exerc = this.worksheet.exercises[currentExerciseIndex + 1]) === null || _this$worksheet$exerc === void 0 ? void 0 : _this$worksheet$exerc.id;
        this.routeStore.routeToNamed(routeName, {
          groupId: this.worksheet.groupId,
          worksheetId: (_this$worksheet4 = this.worksheet) === null || _this$worksheet4 === void 0 ? void 0 : _this$worksheet4.id,
          exerciseId: nextExerciseId
        }, callback);
      }
    }
  }, {
    key: "goToPreviousExercise",
    value: function goToPreviousExercise(callback, routeName) {
      if (this.hasWorksheet && (0, _utils.isPresent)(this.worksheet.exercises) && !this.exerciseIsFirst) {
        var currentExerciseIndex = this.worksheet.exercises.map(function (item) {
          return item.id;
        }).indexOf(this.exerciseId);
        if (currentExerciseIndex > 0) {
          var _this$worksheet$exerc2, _this$worksheet5;
          var previousExerciseId = (_this$worksheet$exerc2 = this.worksheet.exercises[currentExerciseIndex - 1]) === null || _this$worksheet$exerc2 === void 0 ? void 0 : _this$worksheet$exerc2.id;
          this.routeStore.routeToNamed(routeName, {
            groupId: this.worksheet.groupId,
            worksheetId: (_this$worksheet5 = this.worksheet) === null || _this$worksheet5 === void 0 ? void 0 : _this$worksheet5.id,
            exerciseId: previousExerciseId
          }, callback);
        }
      }
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "exerciseId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "assignedExercise", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "revealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentCardId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showAllWorksheetVocab", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "exercises", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "exerciseRatingId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultExerciseId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultExerciseId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsDefault", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedInAndNotGuest", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedInAndNotGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredWorksheetWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredWorksheetWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetHasInvalidVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetHasInvalidVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultSiteHasWorksheetAccess", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSiteHasWorksheetAccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCurrentWorksheetAccess", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCurrentWorksheetAccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "group", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "group"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedYoutubeUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedYoutubeUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasWorksheet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWorksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIsLast", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIsLast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIsFirst", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIsFirst"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseIndex", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignExerciseToCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "assignExerciseToCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasExercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleHideYoutubeVideo", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHideYoutubeVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowAllWorksheetVocab", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowAllWorksheetVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateUser", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createEvent", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignToNextWordAssociation", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "assignToNextWordAssociation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getCookieValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getCookieValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCookieValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setCookieValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignToNextExerciseEntry", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "assignToNextExerciseEntry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeExerciseEntry", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeExerciseEntry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetValueToWordAssociation", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSetValueToWordAssociation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearWordAssociation", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearWordAssociation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAssignedWordAssociations", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setAssignedWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "correctAnswersCount", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "correctAnswersCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetExerciseAnswers", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetExerciseAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetIncorrectExerciseAnswers", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetIncorrectExerciseAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealedEntriesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "revealedEntriesCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealedEntriesCorrectCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "revealedEntriesCorrectCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealExerciseEntryAnswer", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "revealExerciseEntryAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetIncorrectExerciseEntryAnswers", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetIncorrectExerciseEntryAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealExerciseAnswers", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "revealExerciseAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateIndexDataAfterReveal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateIndexDataAfterReveal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichExercise", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getWorksheet", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getWorksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadUser", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetExercise", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markAsCompleted", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "markAsCompleted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "findExerciseAndMarkAsCompleted", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "findExerciseAndMarkAsCompleted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateIndexDataAfterMarkAsCompleted", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateIndexDataAfterMarkAsCompleted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickRating", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onClickRating"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitRatingComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitRatingComment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeckOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "worksheetNamespace", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "worksheetNamespace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToNextExercise", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextExercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPreviousExercise", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "goToPreviousExercise"), _class.prototype), _class);
var _default = exports["default"] = new ExerciseUI();